// Predictive search dropdown — ported from heaven-shopify, adapted for Momentum cart/UI.
(function () {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const inputs = $$('.predictive-search-input');
  const suggestionRoot = $('#predictive-suggestions');
  const searchOverlay = $('#predictive-search-overlay');
  const suggestionLeft = $('#predictive-suggestion-left');
  const suggestionRight = $('#predictive-suggestion-right');

  if (!inputs.length || !suggestionRoot) return;

  let debounceTimer = null;
  let activeQuery = '';
  let isPanelOpen = false;
  let isClosing = false;
  let closeTimer = null;
  const CLOSE_ANIMATION_MS = 450;
  const LEFT_SUGGESTION_LIMIT = 10;
  const CLOSE_ICON_URL = 'https://cdn.shopify.com/s/files/1/0769/8664/6816/files/close.svg?v=1688031682';

  inputs.forEach((input) => {
    input.addEventListener('input', function () {
      const q = this.value.trim();
      syncSearchInputs(this, q);
      handleInput(q);
    });

    input.addEventListener('focus', function () {
      if (this.value.trim().length >= 2 && suggestionRight.innerHTML.trim() !== '') {
        showPanel();
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.predictive-close-btn')) {
      e.preventDefault();
      hidePanel({ animate: true });
      return;
    }

    if (!e.target.closest('.predictive-search-root')) {
      hidePanel();
    }
  });

  function syncSearchInputs(source, value) {
    inputs.forEach((input) => {
      if (input !== source) input.value = value;
    });
  }

  function handleInput(q) {
    clearTimeout(debounceTimer);

    if (q.length < 2) {
      hidePanel();
      return;
    }

    debounceTimer = setTimeout(() => {
      fetchSuggestions(q);
    }, 300);
  }

  async function fetchSuggestions(query) {
    try {
      const url =
        `/search/suggest.json?q=${encodeURIComponent(query)}` +
        `&resources[type]=product&resources[limit]=10`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Suggestion fetch failed');
      const data = await res.json();
      const products = data?.resources?.results?.products || [];
      renderSuggestions(products, query);
    } catch (err) {
      console.error('Predictive search error:', err);
      hidePanel();
    }
  }

  function safeImgUrl(product) {
    if (!product) return '';
    if (product.featured_image && typeof product.featured_image === 'object') {
      return product.featured_image.url || product.featured_image.src || '';
    }
    if (product.featured_image && typeof product.featured_image === 'string') {
      return product.featured_image;
    }
    if (product.image) return product.image;
    return '';
  }

  function handleProductUrl(product) {
    if (product.url) return product.url;
    if (product.handle) return `/products/${product.handle}`;
    return '#';
  }

  function renderSuggestions(products, query) {
    activeQuery = query;

    let leftHTML = '';
    if (products.length > 0) {
      leftHTML += `<div class="roboto-regular text-uppercase fontS mediumLeading font-dark-color mb-3">Suggestions</div><ul class="list-none ps-0 mb-0">`;
      products.slice(0, LEFT_SUGGESTION_LIMIT).forEach((p) => {
        const href = handleProductUrl(p);
        const title = escapeHtml(p.title);
        let highlightedTitle = title;
        if (query) {
          const regex = new RegExp(`(${escapeRegex(query)})`, 'gi');
          highlightedTitle = title.replace(regex, `<span class="font-dark-color">$1</span>`);
        }
        leftHTML += `<li class="mb-2">
          <a class="roboto-regular fontS smallLeading font-darkGrey-color text-decoration-none transition predictive-suggestion-key" href="${href}">
            ${highlightedTitle}
          </a>
        </li>`;
      });
      leftHTML += '</ul>';
    } else {
      leftHTML = `<div class="orpheuspro fontLG mediumLeading font-dark-color mb-2">No suggestions</div>`;
    }

    suggestionLeft.innerHTML = leftHTML;

    let rightHTML = `<div class="predictive-results-header mb-5">
      <div class="row align-items-start g-2">
        <div class="col d-flex justify-content-between align-items-center gap-2">
          <div class="roboto-regular text-uppercase fontS mediumLeading font-dark-color opacity-50 search-card-content-heading mb-0">Results for “${escapeHtml(query)}”</div>
          <button
            type="button"
            class="predictive-close-btn close-btn text-reset bg-pro-bg rounded-circle border-0 d-flex d-lg-none align-items-center justify-content-center"
            aria-label="Close search"
          >
            <img src="${CLOSE_ICON_URL}" alt="">
          </button>
        </div>
        <div class="col-12 col-lg-auto">
          <div class="predictive-results-actions d-flex flex-column align-items-start align-items-lg-end gap-2">
            <button
              type="button"
              class="predictive-close-btn close-btn text-reset bg-pro-bg rounded-circle border-0 d-none d-lg-flex align-items-center justify-content-center"
              aria-label="Close search"
            >
              <img src="${CLOSE_ICON_URL}" alt="">
            </button>
            <a
              class="predictive-view-all text-decoration-none roboto-medium fontM smallLeading font-dark-color border-dark rounded-pill btn black-btn-hvr"
              href="/search?q=${encodeURIComponent(query)}&options[prefix]=last"
            >
              View all results
            </a>
          </div>
        </div>
      </div>
    </div>`;
    rightHTML += `<div class="search-card-content col-lg-12"><div class="row row17">`;

    if (products.length === 0) {
      rightHTML += `<div class="col-12 roboto-regular fontM normalLeading font-darkGrey-color">No products found.</div>`;
    } else {
      products.forEach((p) => {
        const img = safeImgUrl(p) || '';
        const title = p.title || '';
        const desc = (p.body || p.description || '').replace(/(<([^>]+)>)/gi, '').slice(0, 80);
        const price =
          typeof p.price === 'string' && p.price
            ? p.price
            : p.price
              ? formatPrice(p.price)
              : '';
        const handle = p.handle || (p.url ? p.url.split('/products/')[1] : '');
        const productUrl = handleProductUrl(p);

        rightHTML += `
        <div class="col-xl-6 col-lg-5 col-sm-6 col-12 mb-4">
          <div class="result-card p-3">
            <div class="row g-0 align-items-center">
              <div class="mega-img">
                <a href="${productUrl}">
                  <img class="w-100 h-100" src="${img}" alt="${escapeHtml(title)}" loading="lazy">
                </a>
              </div>
              <div class="col-8 ms-3">
                <a href="${productUrl}" class="text-decoration-none">
                  <div class="orpheuspro fontM smallLeading font-dark-color mb-1">${escapeHtml(title)}</div>
                </a>
                <a href="${productUrl}" class="roboto-regular fontXS font-darkGrey-color text-decoration-none mb-2 d-block">${escapeHtml(desc)}</a>
                <div class="d-flex justify-content-between align-items-center flex-row-reverse flex-lg-row">
                  <div class="roboto-medium fontM smallLeading font-dark-color">${price}</div>
                  <button class="roboto-medium fontS smallLeading font-dark-color predictive-add-btn bg-transparent border-0 opacity-50 text-decoration-underline" data-handle="${escapeHtml(handle)}">Add to Basket</button>
                </div>
              </div>
            </div>
          </div>
        </div>`;
      });
    }

    rightHTML += `</div></div>`;
    suggestionRight.innerHTML = rightHTML;

    showPanel();

    $$('.predictive-add-btn', suggestionRight).forEach((btn) => {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        const handle = this.dataset.handle;
        if (!handle) return showToast('Unable to add product.');
        this.disabled = true;
        this.textContent = 'Adding...';
        try {
          await addToCartByHandle(handle);
          this.textContent = 'Added';
          setTimeout(() => {
            this.textContent = 'Add to Basket';
          }, 1500);
        } catch (err) {
          console.error(err);
          showToast('Unable to add product. Try again.', true);
          this.textContent = 'Add to Basket';
        } finally {
          this.disabled = false;
        }
      });
    });
  }

  async function addToCartByHandle(handle) {
    const productRes = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
    if (!productRes.ok) throw new Error('Failed to fetch product details');
    const productJson = await productRes.json();
    const variantId = productJson?.variants?.[0]?.id;
    if (!variantId) throw new Error('No variant found');

    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    if (!addRes.ok) throw new Error('Add to cart failed');

    updateCartCount();
    showToast('Added to basket!');
    return addRes.json();
  }

  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((res) => res.json())
      .then((cart) => {
        $$('.cart-count, #counter').forEach((el) => {
          el.textContent = cart.item_count;
        });

        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.fetchCart === 'function') {
          window.Rebuy.SmartCart.fetchCart();
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(() => {});
  }

  function showPanel() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    isClosing = false;
    isPanelOpen = true;

    document.body.classList.add('predictive-search-open');
    document.body.classList.remove('predictive-search-closing');
    document.documentElement.classList.add('predictive-search-open');

    suggestionRoot.style.display = 'block';
    suggestionRoot.classList.remove('is-closing');
    void suggestionRoot.offsetWidth;
    suggestionRoot.classList.add('active');
    if (searchOverlay) searchOverlay.classList.add('active');
  }

  function finishHide() {
    suggestionRoot.style.display = 'none';
    suggestionRoot.classList.remove('active', 'is-closing');
    if (searchOverlay) searchOverlay.classList.remove('active');
    document.body.classList.remove('predictive-search-open', 'predictive-search-closing');
    document.documentElement.classList.remove('predictive-search-open');
    isPanelOpen = false;
    isClosing = false;
    closeTimer = null;
  }

  function hidePanel(options = {}) {
    const animate = Boolean(options.animate);
    if ((!isPanelOpen && suggestionRoot.style.display === 'none') || isClosing) return;

    document.body.classList.remove('predictive-search-open');
    document.documentElement.classList.remove('predictive-search-open');
    isPanelOpen = false;

    if (searchOverlay) searchOverlay.classList.remove('active');

    if (!animate) {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      document.body.classList.remove('predictive-search-closing');
      finishHide();
      return;
    }

    isClosing = true;
    document.body.classList.add('predictive-search-closing');
    suggestionRoot.classList.add('is-closing');

    closeTimer = setTimeout(finishHide, CLOSE_ANIMATION_MS);
  }

  function showToast(msg, error = false) {
    const toast = document.createElement('div');
    toast.className = 'predictive-cart-toast' + (error ? ' error' : '');
    toast.textContent = msg;
    document.body.appendChild(toast);
    toast.style.opacity = '1';

    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 400);
    }, 2000);
  }

  function formatPrice(value) {
    const num = Number(value);
    if (Number.isNaN(num)) return '';

    // Suggest API returns decimal prices (e.g. 64.00); other endpoints may return cents.
    const decimalAmount = num > 1000 ? num / 100 : num;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(Math.round(decimalAmount * 100));
    }

    return `£${decimalAmount.toFixed(2)}`;
  }

  function escapeHtml(text) {
    if (!text) return '';
    return String(text).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function escapeRegex(text) {
    return String(text).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
})();
